import { render, staticRenderFns } from "./qkallCourse.vue?vue&type=template&id=000cb2fc&scoped=true"
import script from "./qkallCourse.vue?vue&type=script&lang=js"
export * from "./qkallCourse.vue?vue&type=script&lang=js"
import style0 from "./qkallCourse.vue?vue&type=style&index=0&id=000cb2fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000cb2fc",
  null
  
)

export default component.exports